import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static secureInput(control: AbstractControl): ValidationErrors | null {
    const value = (control.value || '').toString().trim();
    const patternsToBlock = [
      /<script[\s\S]*?>[\s\S]*?<\/script>/gi,                    // <script>...</script>
      /<script[\s\S]*>?/gi,                                        // <script ...  (sin cerrar)
      /<[\s\S]+?\s+on\w+\s*=\s*["']?[\s\S]+?>/gi,            // atributos on*
      /javascript\s*:/gi,
      /vbscript\s*:/gi,
      /data\s*:[^,]*?,/gi,                                          // data:text/html;base64,...
      /document\s*\./gi,
      /window\s*\./gi,
      /eval\s*\(/gi,
      /setTimeout\s*\(/gi,
      /setInterval\s*\(/gi,
      /Function\s*\(/gi,
      /<iframe[\s\S]*?>[\s\S]*?<\/iframe>/gi,                    // iframes
      /<object[\s\S]*?>[\s\S]*?<\/object>/gi,                    // <object> tags
      /<embed[\s\S]*?>[\s\S]*?<\/embed>/gi,                      // <embed> tags
      /<svg[\s\S]*?on\w+=['"]?[\s\S]*?>/gi,                     // SVG con eventos
      /<math[\s\S]*?on\w+=['"]?[\s\S]*?>/gi,                    // MathML con eventos
      /style\s*=\s*['"][^'"]*(expression|url\s*\()[\s\S]*?['"]/gi, // inline styles peligrosos
      /<link[\s\S]*?>/gi,                                          // <link> tags
      /<meta[\s\S]*?>/gi,                                          // <meta> tags
      /localStorage/gi,                                              // intento de acceso a localStorage
      /sessionStorage/gi,                                            // intento de acceso a sessionStorage
    ];

    for (const pattern of patternsToBlock) {
      if (pattern.test(value)) {
        return { insecureContent: true };
      }
    }

    const keywordsToBlock = [
      'alert(', 'prompt(', 'confirm(', 'drop table', 'select * from',
      'union select', '--', ';--', '/*', '*/', '@@',
      'char(', 'nchar(', 'varchar(', 'alter table', 'delete from'
    ];

    const lowerValue = value.toLowerCase();
    for (const keyword of keywordsToBlock) {
      if (lowerValue.includes(keyword)) {
        return { insecureKeyword: true };
      }
    }

    return null;
  }
}

export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value || '';
  const plainText = value
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();

  const isWhitespaceOnly = plainText.length === 0;
  return isWhitespaceOnly ? { whitespace: true } : null;
}

export function sanitizeHtml(input: string): string {
  let output = input.replace(/ style="[^"]*"/gi, '');
  output = output.replace(/<!--[\s\S]*?-->/gi, '');
  output = output.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n');
  output = output.replace(/&nbsp;/gi, ' ');
  output = output.replace(/<[^>]+>/g, '');
  output = output.replace(/\n{2,}/g, '\n');
  return output.trim();
}
